import { EMOJIS_TOOL } from '@quicktools/shared-components';

export const VERSION = process.env.NX_APP_VERSION;
export const TOOL_NAME = EMOJIS_TOOL.id;
export const BUGSNAG_ID = process.env.NX_BUGSNAG_ID;
export const TRACKING_ID = process.env.NX_TRACKING_ID;
export const TRACKING_ID_4 = process.env.NX_TRACKING_ID_4;
export const HOTJAR_ID = Number(process.env.NX_HOTJAR_ID);
export const OPTIMIZE_ID = process.env.NX_OPTIMIZE_ID;
export const ONETRUST_ID = process.env.NX_ONETRUST_ID;
export const DEPLOY_PATH = process.env.NX_DEPLOY_PATH;

export const SEARCH_STR = 'search';
